import React, { useContext } from 'react'
import styled from 'styled-components'

import ActivityGauge from '../../../../components/Charts/ActivityChart'
import GoalBarChart from './components/GoalBarChart'
import { FormatAsMoney } from '../../../../components/Fields/NumberFormatFields'
import IpsaContext from '../../../../context/IpsaContext'
import SidebarContext from '../../../../context/SidebarContext'

const GoalWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`

const Container = styled.div`
    height: auto;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    top: 50%;
    transform: translateY(-60%);
`

const InsightGraphs = () => {
    const {
        insights: {
            currentYtdPremiums,
            currentProjectedYtdPremiums,
            ytdPremiumGoal,

            ytdPresentations,
            ytdApplications,
            ytdCasesPlaced,
        },
    } = useContext(IpsaContext)

    return (
        <Container className="col-section col-no-margin">
            <div className="col-xs-12 col-md-5">
                <ActivityGauge
                    title="Your Goal Metric"
                    current={currentYtdPremiums}
                    projected={currentProjectedYtdPremiums}
                    goal={ytdPremiumGoal}
                />
                <GoalWrapper>
                    <h1>Premium Goal</h1>
                    <h3>{FormatAsMoney(ytdPremiumGoal)}</h3>
                </GoalWrapper>
                <GoalWrapper>
                    <h1>Premium YTD</h1>
                    <h3>{FormatAsMoney(currentYtdPremiums)}</h3>
                </GoalWrapper>
            </div>
            <div className="col-xs-12 col-md-7">
                <GoalBarChart
                    title={`${new Date().getFullYear()} KPI's`}
                    presentations={ytdPresentations}
                    applications={ytdApplications}
                    casesPlaced={ytdCasesPlaced}
                ></GoalBarChart>
            </div>
        </Container>
    )
}

export default InsightGraphs
